import { render, staticRenderFns } from "./InventoryVNChart.vue?vue&type=template&id=7696e480&scoped=true&"
import script from "./InventoryVNChart.vue?vue&type=script&lang=js&"
export * from "./InventoryVNChart.vue?vue&type=script&lang=js&"
import style0 from "./InventoryVNChart.vue?vue&type=style&index=0&id=7696e480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7696e480",
  null
  
)

export default component.exports